import React, { useState, useEffect } from "react";
import "./DateTimePicker.css";
import DatePicker, { registerLocale } from "react-datepicker";
import InputMask from "react-input-mask";
import "react-datepicker/dist/react-datepicker.css";
import { es } from "date-fns/locale";

interface DateTimePickerProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
  placeholder?: string;
  defaultTime?: string;
}

const DateTimePicker: React.FC<DateTimePickerProps> = ({
  label,
  value,
  onChange,
  className = "",
  placeholder = "Seleccione fecha y hora",
  defaultTime = "00:00",
}) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [timePart, setTimePart] = useState(defaultTime);

  const formatDateToISO = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const combineDateTime = (date: Date | null, time: string): string => {
    if (!date) return "";
    return `${formatDateToISO(date)}T${time}`;
  };

  useEffect(() => {
    if (value) {
      const [dateStr, timeStr] = value.split("T");
      if (dateStr) {
        const [year, month, day] = dateStr.split("-").map(Number);
        const parsedDate = new Date(year, month - 1, day);
        setSelectedDate(parsedDate);
      }
      if (timeStr) {
        setTimePart(timeStr.substring(0, 5));
      }
    } else {
      setSelectedDate(null);
    }
  }, [value]);

  useEffect(() => {
    if (!value && timePart === "00:00") {
      setTimePart(defaultTime);
    }
  }, [defaultTime]);

  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
    if (date) {
      const newDateTime = combineDateTime(date, timePart);
      onChange(newDateTime);
    } else {
      onChange("");
    }
  };

  const handleTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newTime = e.target.value || "00:00";
    setTimePart(newTime);
    if (selectedDate) {
      const newDateTime = combineDateTime(selectedDate, newTime);
      onChange(newDateTime);
    }
  };

  console.log(defaultTime);

  return (
    <div className={`datetime-picker-container ${className}`}>
      <label className="datetime-picker-label">{label}</label>
      <div className="datetime-picker-wrapper">
        <DatePicker
          selected={selectedDate}
          className="pl-2"
          onChange={handleDateChange}
          onChangeRaw={(e) => {
            if (e && e.target && e.target instanceof HTMLInputElement) {
              const inputValue = e.target.value.replace(/[_\s/]/g, "");
              if (inputValue.length === 0) {
                setSelectedDate(null);
                onChange("");
              }
            }
          }}
          dateFormat="dd/MM/yyyy"
          isClearable
          placeholderText="dd/mm/aaaa"
          showYearDropdown
          locale={es}
          autoComplete="off"
          customInput={
            <InputMask
              mask="99/99/9999"
              placeholder="dd/mm/aaaa"
              alwaysShowMask={false}
            />
          }
        />
        <input
          type="time"
          value={timePart}
          onChange={handleTimeChange}
          className="datetime-picker-time"
          aria-label="Hora"
        />
      </div>
    </div>
  );
};

export default React.memo(DateTimePicker);
